import React, { useState } from "react"

export default function Sidenav({ appProps }) {
  const [drawerOpen, setDrawerOpen] = useState(false)

  const directorNavItems = (appProps.directorNavigationItems || []).map(item => ({
    href: item.path,
    icon: item.icon,
    label: Cas.translations[`sidenav_${item.key}`]
  }))

  const navItems = [
    {
      href: appProps.profilePath,
      icon: 'fa-user',
      label: Cas.translations.sidenav_profile
    },
    {
      href: appProps.chooseAccountPath,
      icon: 'fa-users',
      label: Cas.translations.sidenav_choose_account
    },
    {
      href: appProps.availableInstancesPath,
      icon: 'fa-house-building',
      label: Cas.translations.sidenav_create_instance
    },
    {
      href: appProps.deleteAccountScreenPath,
      icon: 'fa-user-slash',
      label: Cas.translations.sidenav_delete_account
    }
  ].concat(directorNavItems)

  function isActive(path) {
    return window.location.pathname.includes(path)
  }

  return (
    <>
      <button
        type='button'
        className='sidenav-open'
        aria-label='Open navigation'
        aria-expanded={ drawerOpen }
        onClick={ () => setDrawerOpen(true) }>
        <i className='fa-light fa-bars'></i>
      </button>

      <div
        className={ `sidenav-backdrop ${drawerOpen ? 'visible' : ''}` }
        onClick={ () => setDrawerOpen(false) }>
      </div>

      <aside className={ `sidenav ${drawerOpen ? 'open' : ''}` }>
        <div className='sidenav-heading'>
          <div>
            <div className='sidenav-kicker'>{ appProps.instanceName }</div>
            <div className='sidenav-title'>{ Cas.translations.sidenav_profile }</div>
          </div>
          <button
            type='button'
            className='sidenav-close'
            aria-label='Close navigation'
            onClick={ () => setDrawerOpen(false) }>
            <i className='fa-light fa-xmark'></i>
          </button>
        </div>

        <nav className='navigation flex-box flex-column' aria-label='Account navigation'>
          { navItems.map(item => (
            <a
              key={ item.href }
              href={ item.href }
              className={ `link ${isActive(item.href) ? 'active' : ''}` }
              rel='nofollow noindex nofollow'>
              <span className='link-icon'>
                <i className={ `fa-light ${item.icon}` }></i>
              </span>
              <span className='link-label'>{ item.label }</span>
              <i className='fa-light fa-chevron-right link-arrow'></i>
            </a>
          )) }
        </nav>
      </aside>
    </>
  )
}
